var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfilePsswordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 21064"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1 17.8001C1 14.406 1 12.709 2.05442 11.6545C3.10883 10.6001 4.80588 10.6001 8.2 10.6001H17.8C21.1941 10.6001 22.8911 10.6001 23.9456 11.6545C25 12.709 25 14.406 25 17.8001C25 21.1942 25 22.8912 23.9456 23.9457C22.8911 25.0001 21.1941 25.0001 17.8 25.0001H8.2C4.80588 25.0001 3.10883 25.0001 2.05442 23.9457C1 22.8912 1 21.1942 1 17.8001Z",
    stroke: "#008556",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.80078 10.6V8.2C5.80078 4.22355 9.02433 1 13.0008 1C16.9772 1 20.2008 4.22355 20.2008 8.2V10.6",
    stroke: "#008556",
    strokeWidth: 2,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePsswordIcon);
export default __webpack_public_path__ + "static/media/ProfilePsswordIcon.e0476b5434c578c408597f931deac28b.svg";
export { ForwardRef as ReactComponent };